export type Language = 'ru' | 'en';

export const translations = {
  ru: {
    // LoginPage
    logoAlt: 'Логотип',
    loginButton: 'Вход в личный кабинет',
    guestLink: 'Вход без регистрации',
    closeButton: 'Закрыть',
    closePage: 'Закрыть страницу',
    guestError: 'Сбой при входе в режиме \"без регистрации\"',
    modalTitle: 'Личный кабинет',
    labelLogin: 'Логин',
    labelPassword: 'Пароль',
    passwordPlaceholder: 'Введите пароль',
    errorEmptyPassword: 'Введите пароль',
    errorBadCredentials: 'Неверный логин и(или) пароль',
    submitLoading: 'Вход...',
    submitButton: 'Войти',
    cancelButton: 'Отмена',
    viewResultsLink: 'Поиск и получение результатов',

    // HomePage (публичная главная)
    homeSubtitle: 'индикатор скрытых смыслов',

    // Footer
    footerRequisites: 'Реквизиты и условия',
    footerOffer: 'Публичная оферта',
    footerConsent: 'Согласие на обработку персональных данных',
    footerInstruction: 'Инструкция пользователя',
    footerRights: '(с) PsyDecrypt 2026',

    // RequisitesPage
    requisitesTitle: 'Реквизиты и условия',
    requisitesIntro1: 'Услуга состоит в возмездном представлении анонимному пользователю информации в составе файла и является цифровой.',
    requisitesIntro2: 'После успешной оплаты анонимный пользователь получает файл с текстовым описанием результатов сессии (тестирования). Файл с результатом автоматически получает уникальный буквенно-числовой код, по которому этот файл может быть найден на сервисе и скачан на гаджет пользователя.',
    requisitesIntro3: 'Иные способы доставки услуги (в виде файла с информацией) не предусматриваются. Доступ к результату предоставляется сразу после подтверждения платежа. Для поиска и скачивания заключения по его буквенно-числовому коду можно использовать клавишу "Поиск и получение результатов", расположенную на главной странице.',
    requisitesIntro4: 'Во избежание злоупотреблений по умолчанию предоставляется 3 попытки скачивания одного оплаченного файла. Последующий доступ к файлу возможен через форму обращения к администрации сервиса на сайте www.psydecrypt.online или через электронную почту: psydecrypt@mail.ru',
    requisitesPricesTitle: 'Тарифы',
    requisitesPriceIndividual: 'Психологический портрет — 499 ₽',
    requisitesPriceComparison: 'Сравнение двух психопрофилей — 499 ₽',
    requisitesPriceInfo: 'Перечень доступных услуг итеративно расширяется. Их стоимость будет указываться по мере появления. Справки по всем вопросам работы сервиса "Psydecrypt" можно получить у администрации через форму запроса на странице: https://psydecrypt.online/',
    requisitesOfferTitle: 'Публичная оферта',
    requisitesOfferText: 'Публичная оферта размещена на сайте Psydecrypt Online:',
    requisitesRequisitesTitle: 'Реквизиты ИП',
    requisitesName: 'ИП Пилюгин Александр Борисович',
    requisitesInn: 'ИНН: 780411646954',
    requisitesOgrnip: 'ОГРНИП: 323784700082881',
    requisitesAccount: 'Счёт: 40802810555710075196',
    requisitesBank: 'Банк: СЕВЕРО-ЗАПАДНЫЙ БАНК ПАО СБЕРБАНК',
    requisitesBik: 'БИК: 044030653',
    requisitesKor: 'Корсчёт: 30101810500000000653',
    requisitesBankInn: 'ИНН банка: 7707083893',
    requisitesBankKpp: 'КПП банка: 784243001',

    // PrivacyPage — согласие на обработку персональных данных
    privacyTitle: 'Согласие пользователя на обработку персональных данных',
    privacyP1: 'Настоящим я, действуя свободно, своей волей и в своём интересе, даю согласие ИП Пилюгину Александру Борисовичу (ОГРНИП 323784700082881) на обработку моих персональных данных в целях возмездного предоставления мне цифровой услуги через веб-сервис «Psydecrypt».',
    privacyP2: 'Мне известно, что данный веб-сервис не собирает, не проверяет и не хранит какие-либо и чьи-либо персональные данные и что для получения цифровой услуги на сервере «Psydecrypt» регистрация и указание персональных данных не требуются. Доступ к файлам с целевой информацией осуществляется по буквенно-числовому коду, генерируемому веб-сервисом автоматически для каждой отдельной сессии. Этот код присваивается файлам, содержимое которых за плату приобретается пользователем.',
    privacyP3: 'При этом я могу по своему усмотрению добровольно внести в поля идентификации результата (имя, адрес, иные сведения). Такие данные не проверяются, используются только для привязки файла с результатом и не передаются третьим лицам, кроме случаев, предусмотренных законом. При этом мне известно, что я могу вписать любые, как реальные, так и вымышленные данные о себе или ничего не вписывать.',
    privacyP4: 'Оплата цифровых услуг осуществляется через сторонний платёжный сервис. Платёжные данные обрабатываются его оператором в соответствии с его политикой конфиденциальности.',
    privacyP5: 'Я понимаю и принимаю возможные риски: заключение по результатам выполнения мной тестовых заданий формируется LLM-моделью автоматически, в том числе, но не ограничиваясь, с использованием технологий искусственного интеллекта. Информация в заключении является сведениями к ознакомлению и не является медицинским или психологическим заключением, диагнозом или рекомендацией. Также заключение не заменяет консультацию специалиста. Результаты могут содержать неточности, как ввиду неизбежной неполноты метода психологического тестирования.',
    privacyP6: 'Согласие пользователя действует до его отзыва. Отозвать согласие можно по адресу psydecrypt@mail.ru или через форму обращения на сайте psydecrypt.online.',
    privacyConsentLabel: 'Я даю согласие на обработку персональных данных и понимаю риски использования веб-сервиса «Psydecrypt»',

    // OfferPage — публичная оферта
    offerTitle: 'ПУБЛИЧНАЯ ОФЕРТА',
    offerSubtitle: 'на оказание информационно-аналитических (цифровых) услуг',
    offerMetaCity: 'г. Санкт-Петербург',
    offerMetaDate: 'Дата публикации: «20» октября 2026 г.',
    offerIntro: 'Настоящий документ является публичной офертой (далее — «Оферта») Индивидуального предпринимателя Пилюгина Александра Борисовича (ОГРНИП: 323784700082881, ИНН: 780411646954) (далее — «Исполнитель») и содержит все существенные условия договора возмездного оказания информационно-аналитических услуг с любым лицом, которое примет условия настоящей Оферты (далее — «Заказчик»).',
    offerS1Title: '1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ',
    offerS1_1: '1.1. Сервис — веб-сервис «Псидекрипт», доступный по адресу: https://www.psydecrypt.ru (далее — Сервис), представляющий собой программный комплекс для проведения тестирования и генерации аналитических заключений с использованием технологий искусственного интеллекта.',
    offerS1_2: '1.2. Сайт — информационный ресурс Исполнителя, доступный по адресу: https://www.psydecrypt.online.',
    offerS1_3: '1.3. Услуга — предоставление Заказчику доступа к сгенерированному Сервисом цифровому файлу (заключению) на основе ответов, предоставленных Заказчиком при прохождении им тестовых заданий по своему выбору.',
    offerS1_4: '1.4. Акцепт — полное и безоговорочное согласие Заказчика с условиями Оферты, выражаемое путем совершения оплаты Услуг.',
    offerS1_5: '1.5. Код — уникальный буквенно-цифровой код, генерируемый Сервисом автоматически для идентификации сессии и доступа к приобретаемому файлу с результатом.',
    offerS2Title: '2. ПРЕДМЕТ ДОГОВОРА',
    offerS2_1: '2.1. Исполнитель обязуется оказать Заказчику Услуги по предоставлению доступа к цифровым результатам тестирования (информационно-аналитическим заключениям), а Заказчик обязуется оплатить эти Услуги.',
    offerS2_2: '2.2. Перечень доступных Услуг, их детальное описание и актуальная стоимость размещены на Сайте Исполнителя в разделе «Предложения и условия их заказа» ( https://www.psydecrypt.online ).',
    offerS2_3: '2.3. Услуги не являются медицинскими, психологическими или психиатрическими. Результаты носят исключительно информационно-ознакомительный характер и не могут рассматриваться как диагноз или руководство к действию, а также не заменяют консультацию квалифицированного специалиста.',
    offerS3Title: '3. ПОРЯДОК ОКАЗАНИЯ УСЛУГ',
    offerS3_1: '3.1. Для получения Услуги Заказчик проходит тестирование на веб-сервисе, расположенном по электронному адресу https://www.psydecrypt.ru, входящему в состав сайта https://www.psydecrypt.online.',
    offerS3_2: '3.2. По итогам прохождения выбранного потребителем (Заказчиком) теста Сервисом генерируется файл с текстовой информацией, в названии которого содержится уникальный Код, вида RE4WK2HT, под которым этот файл отыскивается Заказчиком, оплачивается, после чего может быть скачан.',
    offerS3_3: '3.3. Услуга является цифровой. Доставка физических носителей не предусматривается.',
    offerS3_4: '3.4. Услуга считается оказанной надлежащим образом и в полном объёме с момента предоставления Заказчику доступа к файлу с результатом (заключением) по сгенерированному коду сразу после подтверждения успешной оплаты.',
    offerS3_5: '3.5. Для получения Услуги Заказчику не требуется проходить регистрацию или указывать свои персональные данные. Любые сведения (имя, адрес и т.д.), вносимые Заказчиком в поля идентификации, используются исключительно для привязки файла и не проверяются на предмет их корректности Исполнителем. Заказчик вправе указать вымышленные данные или оставить поля пустыми.',
    offerS4Title: '4. СТОИМОСТЬ УСЛУГ И ПОРЯДОК ОПЛАТЫ',
    offerS4_1: '4.1. Стоимость Услуг определяется Исполнителем в российских рублях и указывается на Сайте ( https://www.psydecrypt.online ).',
    offerS4_2: '4.2. Оплата Услуг производится в безналичном порядке в форме 100% предоплаты через сторонний платежный сервис (ЮKassa / ООО НКО «ЮМани»). Платежные данные Заказчика (данные банковских карт) обрабатываются исключительно оператором сторонней платежной системы.',
    offerS4_3: '4.3. Совершая оплату, Заказчик подтверждает, что ознакомлен, согласен и принимает условия настоящей Оферты, а также дает согласие на обработку персональных данных в соответствии с Политикой конфиденциальности, размещенной на Сайте.',
    offerS5Title: '5. ПОРЯДОК ВОЗВРАТА ДЕНЕЖНЫХ СРЕДСТВ',
    offerS5_1: '5.1. В связи с тем, что Услуга носит цифровой характер и считается оказанной в момент предоставления доступа к файлу по Обезличенному коду, возврат денежных средств после предоставления доступа к результату не производится, за исключением случаев, прямо предусмотренных законодательством РФ.',
    offerS5_2: '5.2. Если оплата была произведена, но Услуга не была оказана по техническим причинам (например, сбой в работе Сервиса, не позволяющий сгенерировать код или получить доступ к результату), Заказчик вправе обратиться за возвратом средств по адресу электронной почты: psydecrypt@mail.ru. Возврат осуществляется на ту же банковскую карту, с которой была произведена оплата, в сроки, установленные правилами платежной системы.',
    offerS6Title: '6. ПРАВА И ОБЯЗАННОСТИ СТОРОН',
    offerS6_1: '6.1. Исполнитель обязуется обеспечить работоспособность Сервиса и предоставить доступ к результату после успешной оплаты.',
    offerS6_2: '6.2. Заказчик обязуется оплатить выбранную Услугу и не использовать результаты в противоправных целях.',
    offerS6_3: '6.3. Исполнитель вправе вносить изменения в условия Оферты и стоимость Услуг без предварительного уведомления. Изменения вступают в силу с момента публикации на Сайте.',
    offerS7Title: '7. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ И СПЕЦИФИКА РАБОТЫ С ИИ',
    offerS7_1: '7.1. Заказчик понимает и принимает, что заключения формируются настроенной Исполнителем LLM-моделью автоматически с использованием технологий искусственного интеллекта.',
    offerS7_2: '7.2. Исполнитель не гарантирует абсолютную точность, объективность или полноту сгенерированных заключений, так как они зависят от введенных Заказчиком данных, выбранной методики и алгоритмов работы LLM-модели. Результаты могут содержать неточности ввиду неизбежной неполноты метода психологического тестирования и ограничений используемых алгоритмов, а также особенностей выполнения Заказчиком тестовых заданий.',
    offerS7_3: '7.3. Исполнитель не несет ответственности за эмоциональное восприятие Заказчиком полученных результатов, а также за любые решения, действия или бездействие Заказчика, предпринятые им на основе ознакомления с заключением.',
    offerS8Title: '8. ПЕРСОНАЛЬНЫЕ ДАННЫЕ',
    offerS8_1: '8.1. Обработка персональных данных (при их добровольном указании Заказчиком) осуществляется в соответствии с отдельным документом — «Согласие на обработку персональных данных», размещенным на Сайте: https://www.psydecrypt.online.',
    offerS9Title: '9. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ',
    offerS9Name: 'Индивидуальный предприниматель Пилюгин Александр Борисович',
    offerS9Details: 'ИНН: 780411646954\nОГРНИП: 323784700082881\nБанк: СЕВЕРО-ЗАПАДНЫЙ БАНК ПАО СБЕРБАНК\nР/с: 40802810555710075196\nБИК: 044030653\nКор.счёт: 30101810500000000653',
    offerS9ContactsTitle: 'Контакты для связи:',
    offerS9Phone: 'Телефон: +7-961-612-47-20',
    offerS9Email: 'E-mail: psydecrypt@mail.ru',
    offerS9Site: 'Сайт: https://www.psydecrypt.online',
    offerConsentLabel: 'Я ознакомился(лась) с условиями публичной оферты и принимаю их',

    settingsPublicResults: 'Разрешить публичный поиск результатов',
    resultsSettingsError: 'Не удалось сохранить настройку',
    resultCodePlaceholder: 'напр., 1ABCDEF2',
    resultOpen: 'Открыть результаты',
    resultPageTitle: 'Проверка наличия файла с результатами сессии',
    resultCodeLabel: 'Код результата',
    resultCodePrompt: 'Введите буквенно-числовой код интересующей Вас сессии',
    resultCodeRequired: 'Введите код результата',
    resultCodeInvalid: 'Код состоит из 6–15 латинских букв или цифр',
    findConclusion: 'Найти заключение',
    compareProfiles: 'Сравнить психопрофили',
    compareProfilesHint: 'Введите коды подлежащих сравнению описаний психопрофилей субъектов',
    compareCode1Label: 'введите код первого психопрофиля',
    compareCode2Label: 'введите код второго психопрофиля',
    compareMissing: 'заключение под кодом {code} отсутствует в базе',
    compareCodeIsComparison: 'код {code} принадлежит заключению-сравнению, а не индивидуальному психопрофилю',
    compareOpenExisting: 'Открыть готовое сравнение',
    compareSameCode: 'Введите два разных кода',
    compareTestLabel: 'Тест',
    compareDifferentTest: 'Заключения получены по разным тестам ({t1} и {t2}). Сравнение недоступно.',
    compareGetResultBtn: 'Получить результат сравнения',
    comparePageTitle: 'Сравнить психопрофили',
    compareResultTitle: 'Сравнение психопрофилей',
    compareResultPrice: 'Стоимость сравнения',
    compareNotFound: 'Сравнение с таким кодом не найдено',
    compareLoadError: 'Не удалось загрузить сравнение. Проверьте коды и доступность сервера.',
    compareResultBack: 'Возврат к предыдущему окну',
    comparePayment: 'Оплатить и получить заключение',
    comparePaymentLoading: 'Переход к оплате...',
    compareDownload: 'Забрать заключение ({n})',
    compareProcessingInfo: 'Сравнение психопрофилей формируется. Результат будет доступен в течение 10–15 минут.',
    comparePurposeLabel: 'Цель сравнения',
    comparePurposePlaceholder: 'Выберите цель сравнения (необязательно)',
    comparePurposeAny: 'Общее сравнение (цель не выбрана)',
    comparePurposeDescriptionLabel: 'Уточнение цели',
    comparePurposeDescriptionPlaceholder: 'Например: хотим оценить совместимость будущих партнёров по бизнесу...',
    comparePurposeConfirm: 'Цель сравнения учитывается при формировании заключения',
    resultStatusLabel: 'Статус',
    resultPaidLabel: 'Тест оплачен',
    resultPdfLink: 'Скачать PDF с результатами',
    resultWalletOnePayment: 'Оплатить и получить заключение',
    resultPaymentLoading: 'Переход к оплате...',
    resultLoadError: 'Не удалось загрузить результат. Проверьте код и доступность сервера.',
    resultCodeNotFound: 'Файл под указанным кодом не найден. Проверьте корректность введённого кода или обратитесь к администрации сервиса через форму обратной связи на сайте www.psydecrypt.online',
    resultBackToCode: 'Вернуться на страницу ввода кода',
    resultPaymentError: 'Не удалось связаться с Wallet One или сервером. Попробуйте ещё раз.',
    resultPaymentFormLabel: 'Форма перехода к оплате Wallet One',
    resultPaymentNotConfigured: 'Оплата пока не настроена на сервере. Обратитесь к администратору.',
    resultPaymentResultNotFound: 'Результат с таким кодом не найден.',
    resultStatus_processing: 'В обработке',
    resultStatus_awaiting_payment: 'Ожидает оплаты',
    resultStatus_results: 'Результаты',
    resultStatusRejected: 'Обработка отклонена',
    resultStatusPaidAvailableOne: 'Оплачено. Доступно (1) раз',
    resultStatusPaidAvailableFew: 'Оплачено. Доступно ({n}) раза',
    resultStatusLimitReached: 'Достигнут лимит скачиваний',
    resultPriceLabel: 'Стоимость',
    resultCurrency: '₽',
    resultPaymentSuccess: 'Платёж отправлен. Проверяем его статус.',
    resultPaymentFail: 'Платёж не завершён. Проверьте статус оплаты ниже.',
    resultPaymentRedirect: 'Переходим на страницу оплаты...',
    resultPaymentUnavailable: 'Ссылка на оплату недоступна. Попробуйте ещё раз позже.',
    resultProcessingInfo: 'В настоящее время первичные данные обрабатываются и заключение находится в процессе формирования. Результат будет доступен в течение 10–15 минут. Страница обновится автоматически.',
    resultGeneratingInfo: 'Обмен данными с сервисом анализа заключений… {s}',
    resultProcessingWait: 'Запрошенный результат обрабатывается. Ожидайте',
    resultQueuedInfo: 'Ваш запрос поставлен в очередь. Перед вами ещё {n} заявок. Заключение появится автоматически, как только дойдёт очередь.',
    resultGenerationServiceError: 'AI-сервис не отвечает на запросы. Обратитесь к администратору на эл. адрес: psydecrypt@mail.ru или попробуйте получить результат позже.',
    resultProcessError: 'Не удалось запустить обработку. Попробуйте ещё раз позже.',
    resultRetryButton: 'Попробовать снова',
    resultRetryAfter: 'Повторите через {n} сек.',
    resultAttemptsExceeded: 'Лимит попыток исчерпан. Обратитесь к администратору на эл. адрес: psydecrypt@mail.ru.',
    resultAwaitingPaymentInfo: 'Заключение готово. Для доступа к результатам оплатите заказ.',
    resultResultsInfo: 'Оплата подтверждена, результаты доступны для скачивания.',
    resultConclusionInfo: 'В случае возникновения каких-либо вопросов Вы можете обратиться к администрации сервиса через форму на сайте: https://www.psydecrypt.online/, указав код результата сессии вида ХХХХХХХХ',
    resultDownloadButton: 'Забрать заключение ({n})',
    resultDownloadUnavailable: 'Заключение ещё не создано',
    resultPdfDownloadError: 'Не удалось скачать PDF',
    resultPdfPaymentRequired: 'Скачивание доступно после оплаты',
    resultDownloadRequiresPayment: 'Заключение может быть доступно после оплаты',
    resultDownloadsInfoOne: 'Заключение доступно (1) раз',
    resultDownloadsInfoFew: 'Заключение доступно ({n}) раза',
    resultDownloadLimitReached: 'Данное заключение было оплачено, но скачано предусмотренное количество раз ({times}). За каждой последующей копией обращайтесь к администрации сервиса по адресу: https://www.psydecrypt.online',
    compareDownloadPlaceholder: 'Скачать результат сравнения психопрофилей',

    // TestsPage
    pageTitle: 'Выберете методику, которой хотите воспользоваться и кликните на клавишу "Выполнить тест"',
    greeting: 'Рады приветствовать Вас на платформе',
    navUsers: 'Пользователи',
    navResults: 'Результаты',
    createTest: 'Создать тест',
    importTest: 'Загрузить тест из файла',
    importError: 'Не удалось загрузить тест',
    logout: 'Выход',
    loading: 'Загрузка тестов...',
    errorPrefix: 'Ошибка',
    stimuliLabel: 'Стимулов',
    publishedLabel: 'Опубликован',
    publishedYes: 'Да',
    publishedNo: 'Нет',
    startTest: 'Выполнить тест',
    noStimuli: 'Нет доступных стимулов',
    unpublish: 'Снять с публикации',
    publish: 'Опубликовать',
    noVisibleStimuli: 'Нет видимых стимулов',
    exportTest: 'Выгрузить тест',
    editTitle: 'Редактировать',
    deleteTitle: 'Удалить тест',
    testsDisplayScaleLabel: 'Размер карточек:',
    testsDisplayDragHint: 'Перетащите карточку мышкой или укажите номер очереди слева сверху.',
    testsDisplayDragHandle: 'Перетащить карточку',
    testsDisplayOrderTitle: 'Номер очереди (от левого верхнего угла)',
    testsDisplaySaved: 'Настройки отображения сохранены',
    testsDisplaySaveError: 'Не удалось сохранить настройки отображения',
    testsDisplaySaving: 'Сохранение…',
    deleteConfirmPrefix: 'Удалить тест',
    deleteConfirmSuffix: '? Это действие необратимо',

    // TestPage — прохождение
    testLoading: 'Загрузка теста...',
    testNotFound: 'Тест не найден',
    testNoStimuli: 'В этом тесте нет доступных стимулов',
    testPaused: 'Тест приостановлен',
    testResume: 'Продолжить',
    btnBack: '← Назад',
    btnSubmitCustomAnswer: 'Принять ответ',
    btnOk: 'Всё понятно',
    questionCounter: 'из',
    customAnswerPlaceholder: 'Ваш вариант ответа...',
    customAnswerOpen: 'Свой ответ',
    customAnswerTitle: 'Свой вариант ответа',
    clicksProgress: 'Кликов: {k} из {n}',
    scaleConfirm: 'Ответ подтверждаю',

    // TestPage — форма участника
    formTitle: 'Тест завершён', // Было: Задания выполнены успешно! 
    formSubtitle: 'для получения заключения сделайте запрос',// Было: Для получения результатов выполните запрос
    formName: '',// Было: Как к Вам обращаться?
    formNameOptional: '',// Было: слово "необязательно"
    formNamePlaceholder: 'любое имя для связи с результатами (факультативно)',
    formDevice: '',//Было: Устройство
    formDeviceDefault: 'устройство, с которого выполнялся тест',//Было: Выберите устройство...
    formDevicePC: 'Компьютер / ноутбук',
    formDevicePhone: 'Смартфон',
    formDeviceTablet: 'Планшет',
    formEmail: '',// Было: Куда выслать результаты
    formEmailPlaceholder: 'Укажите канал получения результатов. Напр.: My_email@bk.com',//Было: email@example.com
    formAge: '',//Было: Возраст
    formAgePlaceholder: 'Ваш возраст',
    formGender: '',//Было: Пол
    formGenderNone: 'Не указан',
    formGenderMale: 'Мужской',
    formGenderFemale: 'Женский',
    formSubmitting: 'Отправка...',
    formSubmit: 'Запрос заключения',//Было: Запросить результаты
    formSubmitError: 'Не удалось сохранить результат. Проверьте соединение и попробуйте ещё раз — ответы не потеряны.',
    formSkipSave: 'Выйти без запроса и сохранения',//Было: Не сохранять результаты

    // Share code / compare
    shareCodeTitle: 'Код результатов сессии',// Было: Ваш код результата
    shareCodeCopy: 'Копировать',
    shareCodeCopied: 'Скопировано!',
    dbTransferTitle: 'Управление базой данных',
    dbTransferSubtitle: 'Экспорт полного архива БД и импорт в режиме «долить недостающие»: существующие записи не изменяются.',
    dbExportLabel: 'Экспорт',
    dbExportDesc: 'Выгрузить весь архив текущей БД (все таблицы + PDF) в JSON-файл.',
    dbExportBtn: 'Скачать архив БД',
    dbImportLabel: 'Импорт',
    dbImportDesc: 'Выберите JSON-архив БД из другого сервиса. Будут добавлены только отсутствующие записи; совпадающие записи пропускаются.',
    dbImportDrop: 'Перетащите файл сюда',
    dbImportBtn: 'Долить недостающие',
    dbImportLoading: 'Импорт выполняется…',
    dbImportSuccess: 'Импорт завершён',
    dbImportError: 'Ошибка импорта',
    dbStatsLabel: 'Текущая БД',
    dbExportLoading: 'Экспорт выполняется…',
    dbImportFileSelected: 'Выбран файл: {name}',
    dbProgressDownload: 'Скачивание архива БД…',
    dbProgressUpload: 'Загрузка архива БД…',
    dbProgressWait: 'Пожалуйста, подождите…',
    dbIncludePdfs: 'Включить PDF-файлы (заключения)',
    dbMaxArchiveSize: 'Максимальный размер архива: {size}',
    dbExportedSize: 'Скачано: {size}',
    dbNearLimit: 'Архив близок к лимиту переноса ({size} из {limit}). При достижении {limit} импорт станет невозможен — сохраните копию БД.',
    dbFileTooLarge: 'Файл превышает лимит {size} — импорт невозможен. Выгрузите архив без PDF или сохраните копию БД.',
    dbReportPdf: 'PDF',
    dbPdfNotFound: 'PDF не включены в архив. Их можно сформировать заново на этом сервере (кнопка «PDF» у заключения).',
    dbImportReportAdded: 'Добавлено',
    dbImportReportSkipped: 'Пропущено',
    dbImportReportErrors: 'Ошибки',
    backBtn: '← Назад',
    testTitle: 'Тест',
    dbScenarioTitle: 'Перенос сценария с графикой',
    dbScenarioDesc: 'Выгрузите тест вместе с изображениями/видео (zip-бандл) с одной копии и залейте на другую. Графика и ссылки восстановятся автоматически.',
    dbScenarioExportLabel: 'Экспорт сценария',
    dbScenarioExportDesc: 'Выберите тест — будет скачан zip с его JSON-сценарием и всеми медиа-файлами.',
    dbScenarioExportHint: 'В бандл попадут только файлы, на которые ссылается сценарий.',
    dbScenarioExportBtn: 'Скачать бандл сценария',
    dbScenarioExporting: 'Экспорт…',
    dbScenarioNoTests: 'Нет тестов',
    dbScenarioImportLabel: 'Импорт сценария',
    dbScenarioImportDesc: 'Загрузите zip-бандл сценария. Медиа восстановятся, тест добавится без дубликатов.',
    dbScenarioDrop: 'Перетащите zip-бандл сюда',
    dbScenarioImportBtn: 'Загрузить бандл',
    dbScenarioImporting: 'Импорт…',
    dbScenarioImportError: 'Ошибка переноса сценария',
    dbScenarioExportError: 'Не удалось выгрузить бандл сценария',
    dbScenarioBadFile: 'Выберите файл .zip (бандл сценария)',
    dbScenarioMediaMissing: 'Предупреждение: {n} медиа-файл(а) не найдено в архиве — ссылки на них останутся как есть.',
    dbScenarioResultOk: 'Импорт завершён: стимулов {questions}, вариантов {options}; графики добавлено {media_added}, уже было {media_skipped}.',
    dbScenarioResultDuplicate: 'Тест «{title}» уже есть — пропущен.',

    // Conclusion
    conclusionTitle: 'Заключение',
    conclusionLoading: 'Получение заключения...',
    conclusionGetBtn: 'Получить заключение',
    conclusionError: 'Ошибка при получении заключения',
    conclusionResponse: 'Текст заключения',
    navConclusions: 'Заключения',
    navDbTransfer: 'Управление БД',
    navMedia: 'Медиатека',
    navBack: 'Назад к тестам',
    mediaTitle: 'Медиатека',
    mediaUploadBtn: 'Загрузить медиа',
    mediaUploadTitle: 'Загрузка файла',
    mediaFileLabel: 'Файл (изображение или видео до 3 мин)',
    mediaTitleLabel: 'Название',
    mediaDescLabel: 'Описание',
    mediaTagsLabel: 'Теги',
    mediaLoading: 'Загрузка…',
    mediaEmpty: 'В медиатеке пока нет файлов. Загрузите первый.',
    mediaUploadError: 'Не удалось загрузить файл',
    mediaLoadError: 'Не удалось загрузить медиатеку',
    mediaSaveError: 'Не удалось сохранить изменения',
    mediaUploading: 'Загрузка…',
    mediaEditBtn: 'Изменить',
    mediaDeleteBtn: 'Удалить',
    mediaEditTitle: 'Редактирование медиа',
    mediaSaveBtn: 'Сохранить',
    mediaDeleteConfirm: 'Удалить этот файл из медиатеки?',
    mediaCopyLink: 'Скопировать ссылку',
    mediaCopied: 'Скопировано',
    mediaCopyError: 'Не удалось скопировать ссылку',
    mediaSearchPlaceholder: 'Поиск по названию, файлу, описанию, тегам…',
    mediaNoMatch: 'Ничего не найдено. Уточните запрос.',
    mediaTagClickHint: 'Показать файлы с этим тегом',
    conclusionsPageTitle: 'Управление заключениями',
    conclusionsEmpty: 'Нет сохранённых заключений',
    conclusionsLoading: 'Загрузка...',
    conclusionEdit: 'Редактировать',
    conclusionSave: 'Сохранить',
    conclusionSaving: 'Сохранение...',
    conclusionSaveError: 'Ошибка при сохранении',
    conclusionPdf: 'Скачать PDF',
    conclusionPdfError: 'Ошибка сохранения заключения',
    conclusionPdfDownload: 'Скачать PDF',
    conclusionPdfDownloading: 'Скачивание...',
    conclusionPdfDownloadError: 'Ошибка скачивания PDF',
    conclusionPdfPaymentRequired: 'Скачивание доступно после оплаты',
    conclusionGenerate: 'Сгенерировать заключение',
    conclusionGenerateColor: 'Сформировать первичные данные',
    conclusionGenerating: 'Генерация...',
    conclusionGenerateError: 'Ошибка генерации',
    conclusionGeneratingInfo: 'Идёт обмен данными с внешним сервисом... {s}',
    conclusionRegenerateConfirm: 'Для выбранного результата заключение уже имеется. Заменить его новым текстом?',
    conclusionTimeChart: 'График времени',
    conclusionViewAnswers: 'Просмотреть ответы',
    conclusionRequestBtn: 'Запросить заключение',
    conclusionRequested: 'Запрошено ✓',
    conclusionRequestError: 'Ошибка при запросе заключения',
    conclusionNoText: '(текст ещё не сгенерирован)',
    conclusionTextPlaceholder: 'Здесь появится текст заключения...',
    conclusionSaveChanges: 'Сохранить правку текста',
    conclusionDraftSaved: 'Правка сохранена (черновик). Номер изменится после генерации',
    conclusionEditInfo: 'правка №{n} от {d}',
    pdfTitle: 'Психологическое заключение',
    pdfParticipant: 'Участник',
    pdfAge: 'Возраст',
    pdfGender: 'Пол',
    pdfDevice: 'Устройство',
    pdfDate: 'Дата',
    pdfTest: 'Методика',
    pdfCode: 'Код',
    detailResults: 'Результаты',
    conclusionsColType: 'Тип заключения',
    conclusionsColCode: 'Код',
    conclusionsColDate: 'Дата',
    conclusionsColPreview: 'Фрагмент',
    conclusionsColGeneration: 'Статус генерации',
    conclusionsTypeIndividual: 'Индивидуальное',
    conclusionsTypeGroup: 'Групповое',
    conclusionsTypeComparison: 'Сравнение',
    conclusionsColDownloadLimit: 'Лимит скачиваний',
    conclusionsColVisibility: 'Видимость заключения',
    conclusionsColAllowUnpaid: 'Скачивание без оплаты',
    conclusionsColPayment: 'Оплата',
    conclusionsColPublicCount: 'Скачано (публично)',
    conclusionsColTotalCount: 'Скачано (всего)',
    conclusionsColAdminAction: 'Действия',
    conclusionsResetDownloads: 'Сбросить счётчики',
    conclusionsMarkPaid: 'Отметить оплату',
    conclusionsDownloadLimitPlaceholder: '0…10',
    conclusionsDownloadLimitDefault: '3 (по умолчанию)',

    // ConclusionsListPage — действия админа и сообщения
    conclusionsBtnPay: 'Оплатить',
    conclusionsBtnUnmarkPaid: '↩ Снять оплату',
    conclusionsBtnUnmarkPaidTitle: 'Снять пометку ручной оплаты (вернуть в «нет»)',
    conclusionsConfirmUnmarkPaid: 'Снять пометку ручной оплаты заключения?',
    conclusionsUnmarkPaidDone: 'Ручная оплата снята',
    conclusionsBtnPayTitle: 'Проставить оплату',
    conclusionsBtnResetTitle: 'Сбросить счётчик',
    conclusionsBtnDeleteTitle: 'Удалить',
    conclusionsPaymentNone: 'нет',
    conclusionsPaymentManual: 'ручная',
    conclusionsDownloadedCount: 'Скачано: {n} из {m}',
    conclusionsConfirmReset: 'Сбросить счётчик скачиваний?',
    conclusionsConfirmAction: 'Подтвердить',
    conclusionsConfirmDelete: 'Удалить заключение?',
    conclusionsResetDone: 'Счётчик сброшен. Скачано: {n} из {m}.',
    conclusionsErrorUpdateLimit: 'Ошибка обновления лимита',
    conclusionsErrorUpdateVisibility: 'Ошибка обновления видимости заключения',
    conclusionsErrorUpdateUnpaid: 'Ошибка обновления флага без оплаты',
    conclusionsErrorMarkPaid: 'Ошибка установки оплаты',
    conclusionsErrorReset: 'Ошибка сброса счётчика',
    conclusionsErrorDelete: 'Ошибка удаления',
    conclusionsLoadError: 'Не удалось загрузить список заключений',
    conclusionsPdfDownloadError: 'Ошибка скачивания PDF',
    conclusionsPdfDownloadTitle: 'Скачать PDF заключения',
    conclusionsOpenTitle: 'Перейти к заключению (PDF ещё не сформирован)',
    conclusionsSourceExist: 'первичка есть',
    conclusionsSourcePartialMissing: 'частично удалена: {ids}',
    conclusionsSourceMissing: 'первичка удалена: {ids}',
    conclusionsHideOrphans: 'Скрыть без первички',
    conclusionsJobsProcessing: 'В обработке: {p}',
    conclusionsJobsQueued: 'в очереди: {q}',
    conclusionsColGenerating: 'Формируется…',
    conclusionsCodeSearch: 'Поиск по коду заключения',
    conclusionsDeleteOrphans: 'Удалить без первички',
    conclusionsConfirmDeleteOrphans: 'Удалить заключения без первичных результатов ({n} шт.)?',
    conclusionsDeletedOrphans: 'Удалено заключений: {n}',
    conclusionsNoVisible: 'Все заключения скрыты фильтром',
    conclusionExistsLink: 'Заключение есть →',
    conclusionExistsShort: 'Заключение есть',
    conclusionAbsentShort: 'Заключения нет',
    conclusionSourceCodes: 'Коды первичек',
    conclusionSourceMissing: 'Первички удалены (ID)',

    // Scroll to top button (ResultsPage, ConclusionPage)
    scrollTopTitle: 'Наверх',

    // ConclusionPage — метки редактора заключений
    conclusionUpdate: 'Обновить',
    conclusionCoefficient: 'Коэффициент',
    conclusionParameter: 'Параметр {letter}',
    conclusionInAlgorithm: 'Участвует в алгоритме: {vars}',
    conclusionRequiredFields: '⚠ Заполните обязательные поля',
    conclusionSavedMark: '✓ сохранено',
    conclusionCustomLoadError: 'Ошибка загрузки свободных ответов',
    conclusionCustomSaveError: 'Ошибка сохранения',
    conclusionDeleteConfirm: 'Удалить это заключение?',
    conclusionDeleteError: 'Ошибка удаления',
    conclusionModeRaw: 'Первичные данные',
    conclusionModeSaved: 'Текст заключения',
    conclusionRawHint: 'В поле — метаданные первички. Можно отправить их в LLM и получить альтернативное заключение (новая версия).',
    conclusionVersionPublic: 'публично',
    conclusionVersionHidden: 'скрыто',
    conclusionVersionVisibleToPublic: 'Видно внешним пользователям',
    conclusionVersionVisible: 'Версия заключения открыта для внешних пользователей',
    conclusionVersionHiddenDone: 'Версия заключения скрыта от внешних пользователей',
    conclusionVersionCode: 'Код версии: {code}',
    conclusionParticipantFallback: 'Участник',

    // TestPage — экран благодарности
    thanksTitle: '',//Было: Благодарим за участие
    thanksResultsLink: 'Открыть результаты',
    thanksContact: 'По всем вопросам обращаться к администратору сервиса:',// Было: Если есть какие-либо вопросы, Вы можете обратиться к администрации сервиса

    // MyResultsPage
    navMyResults: 'Мои результаты',
    myResultsTitle: 'Мои результаты',
    myResultsEmpty: 'Результатов пока нет',
    myResultsColTest: 'Тест',
    myResultsColDate: 'Дата',
    myResultsColTime: 'Время (сек)',
    myResultsColCompare: 'Сравнение',
    myResultsColQuestion: 'Вопрос',
    myResultsColAnswer: 'Ответ',
    myResultsColTimeMs: 'Время (мс)',

    // Common / shared
    genLoading: 'Загрузка...',
    genSaving: 'Сохранение...',
    genCreate: 'Создать',
    genSave: 'Сохранить',
    genDelete: 'Удалить',
    genCancel: 'Отмена',

    // ResultsPage
    resultsTitle: 'Результаты тестирования',
    resultsLoading: 'Загрузка результатов...',
    resultsLoadError: 'Не удалось загрузить результаты. Проверьте соединение и попробуйте позже.',
    resultsAllTests: 'Все тесты',
    resultsSearch: 'Поиск по пользователю, имени, email...',
    resultsCols: 'Столбцы ▾',
    resultsEmpty: 'Нет результатов',
    resultsShown: 'Показано',
    resultsFrom: 'из',
    resultsSelectedCount: 'Выбрано',
    resultsWithParams: 'С параметрами стимулов',
    resultsExportBtn: 'Детальный экспорт',
    resultsDeleteBtn: 'Удалить выбранные',
    resultsDeletingLabel: 'Удаление...',
    resultsViewBtn: 'Просмотреть ответы',
    resultsViewTooMany: 'Слишком много (макс. 5)',
    resultsViewDiffTests: 'Разные тесты',
    resultsTipMax5: 'Можно сравнивать не более 5 участников',
    resultsTipOneTest: 'Можно сравнивать результаты только одного теста',
    resultsDeleteConfirm: 'Удалить {n} результат(ов)? Это действие необратимо.',
    resultsDeleteError: 'Не удалось удалить результаты',
    resultsViewError: 'Не удалось загрузить детали результатов',
    resultsTooManyAlert: 'Можно сравнивать не более 5 участников одновременно',
    resultsDiffTestsAlert: 'Можно сравнивать результаты только одного теста',
    resultsColId: 'ID',
    resultsColTest: 'Тест',
    resultsColUser: 'Пользователь',
    resultsColName: 'Имя',
    resultsColDevice: 'Устройство',
    resultsColAge: 'Возраст',
    resultsColGender: 'Пол',
    resultsColTime: 'Время (сек)',
    resultsColDate: 'Дата',
    resultsColShareCode: 'Код',
    resultsColPdf: 'PDF',
    resultsColPayment: 'Оплата',
    resultsColDownloads: 'Скачиваний',
    resultsPdfDownload: 'Скачать',
    resultsPdfDownloadError: 'Не удалось скачать PDF',
    resultsPdfPaymentRequired: 'Скачивание доступно после оплаты',
    resultsLoadMore: 'Загрузить ещё',
    resultsPartialLoad: 'Загружено {n} из {total}',
    editorAutoSaveError: '⚠ Ошибка автосохранения',

    // ResultDetailView
    detailBack: '← К списку',
    detailTitle: 'Просмотр ответов',
    detailParticipant1: 'участник',
    detailParticipantsN: 'участников',
    detailSearch: 'Поиск по тексту стимула...',
    detailOnlyAnswered: 'Только отвеченные',
    detailStimuliLabel: 'стимулов',
    detailColN: '№',
    detailColStimulus: 'Стимул',
    detailNoStimuli: 'Нет стимулов',
    detailMs: 'мс',
    detailCustomAnswerLabel: 'своб.',

    // TestEditorPage
    editorTitleNew: 'Создание теста',
    editorTitleEdit: 'Редактирование теста',
    editorRestoreMsg: 'Найдена несохранённая сессия. Восстановить последние изменения?',
    editorRestore: 'Восстановить',
    editorDiscard: 'Отклонить',
    editorLabelName: 'Название теста *',
    editorPlaceName: 'Введите название теста',
    editorErrorName: 'Название обязательно',
    editorLabelDesc: 'Описание',
    editorPlaceDesc: 'Введите описание теста',
    editorLabelMethodology: 'Индикатор методики',
    editorPlaceMethodology: 'например: Шкала СД (методика ЧОУ-3)',
    editorMethodologyHint: 'По этому индикатору AI выбирает промпт обработки первички. Пусто → первичка обрабатывается напрямую, без специальных инструкций.',
    editorColorModeLabel: 'Режим цветомера',
    editorColorModeHint: 'В режиме цветомера участник выбирает из 8 цветных ячеек. Варианты ответов-откликов не используются.',
    editorColorLabelsTitle: 'Названия цветовых меток',
    editorColorLabelsHint: 'Укажите названия для 8 цветовых меток (пусто → hex-код)',
    editorColorPairIndexTitle: 'Матрица ИЦ (индекс цветопары)',
    editorColorPairIndexHint: 'Значение на пересечении строки (первый клик) и столбца (второй клик). 8×8, 0–1.',
    editorLabelShuffle: 'Диапазоны перемешивания',
    editorPlaceShuffle: 'например: 1-5, 8-12',
    editorShuffleHint: 'Стимулы в каждом диапазоне будут перемешаны случайно при прохождении. Номера 1-based, совпадают с порядком стимулов.',
    editorShuffleErrorFormat: 'Неверный формат. Используй вид: 1-5, 8-12',
    editorShuffleErrorOrder: 'Начало диапазона не может быть больше конца',
    editorShuffleErrorMax: 'Конец диапазона превышает количество стимулов ({n})',
    editorStimuliSection: 'Стимулы',
    editorStimulusN: 'Стимул',
    editorHiddenBadge: '(скрыт)',
    editorBtnCopy: 'Копировать',
    editorHideLabel: 'Скрыть',
    editorCustomAnswerLabel: 'Свободный ответ',
    editorJustifyLabel: 'Выровнять текст по ширине',
    editorFontDefault: 'Кегль: обычный',
    editorFontTitle: 'Размер шрифта стимула при прохождении теста',
    editorClicksDefault: 'Кликов: 1',
    editorClicksTitle: 'Сколько кликов по клавишам ОтО до смены стимула (не больше числа клавиш)',
    editorBtnDelete: 'Удалить',
    editorLabelStimulusText: 'Текст стимула',
    editorLabelStimulusMedia: 'Изображение стимула (URL из Медиатеки)',
    editorPlaceStimulusMedia: 'Напр., /api/media/12/file',
    editorStimulusMediaHint: 'Вставьте ссылку из медиатеки, чтобы предъявить картинку/видео как стимул. Поле картинки делает стимул медиа-типом.',
    editorPlaceStimulusText: 'Введите текст стимула',
    editorLabelInfo: 'Информация для участника (кнопка ℹ)',
    editorPlaceInfo: 'Доп. информация, которую участник может открыть нажав ℹ во время теста',
    editorLabelExposition: 'Экспозиция (сек)',
    editorPlaceNoLimit: '0 = без ограничения',
    editorHintNoLimit: '0 = без ограничения времени',
    editorMetaStimulus: 'Мета стимула (a-z)',
    editorHideColorLabels: 'Скрыть цветовые метки',
    editorHideColorLabelsHint: 'Если включено, стимул предъявляется без выбора цветов — только кнопка «Продолжить»',
    editorLabelOptions: 'Варианты ответов-откликов',
    editorAnswerFormLabel: 'Форма ответа',
    editorAnswerFormButtons: 'Кнопки (варианты ответов)',
    editorAnswerFormScale: 'Шкала (семантический дифференциал)',
    editorAnswerFormScaleHint: 'Бегунок с плашками и кнопка «Далее»; балл = значение шкалы',
    editorOptionPlaceholder: 'Вариант',
    editorOptionScore: 'Балл',
    editorOptionMediaPlaceholder: 'URL картинки (Медиатека/внешний)',
    editorMetaOptionPrefix: 'Мета варианта',
    editorMetaOptionSuffix: '(a-z)',
    editorAddOption: '+ Добавить вариант ответа-отклика',
    editorAddStimulus: '+ Добавить стимул',
    editorLabelAlgorithm: 'Алгоритм анализа (для AI)',
    editorPlaceAlgorithm: 'Опишите правила интерпретации результатов теста для AI...',
    editorAlgorithmHint: 'Этот текст передаётся AI при генерации заключения по результатам данного теста',
    algoTitle: 'Алгоритм анализа',
    algoDefaultLetter: 'Буква параметра по умолчанию',
    algoDefaultLetterHint: 'Используется для вопросов, не включённых ни в одну переменную',
    algoAddVariable: '+ Добавить переменную',
    algoVarName: 'Название переменной',
    algoVarQuestions: 'Номера вопросов',
    algoVarQuestionsHint: 'Через запятую: 1, 3, 7',
    algoVarPosLetter: '+ буква',
    algoVarNegLetter: '− буква',
    algoVarPosLetterHint: 'Параметр при сумме коэфф. ≥ 0',
    algoVarNegLetterHint: 'Параметр при сумме коэфф. < 0',
    algoVarDelete: 'Удалить',
    algoHint: 'Алгоритм формирует текст из параметров вариантов ответов и отправляет его в AI (только для тестов без цветомера)',
    algoNoVariables: 'Нет переменных — для всех вопросов используется буква по умолчанию',
    algoColorModeDisabled: 'Алгоритм анализа не применяется в режиме цветомера',
    algoFuncSum: 'По сумме',
    algoFuncPer: 'По каждому',
    algoFuncSumHint: 'Сумма коэффициентов всех вопросов переменной → определяет букву для всех',
    algoFuncPerHint: 'Коэффициент каждого вопроса анализируется независимо',
    algoRuleSumMin: 'сумма',
    algoRuleCoeffMin: 'коэфф.',
    algoRuleElse: 'иначе',
    algoAddRule: '+ Правило',
    algoSingleQuestion: 'Один вопрос — автоматически берётся параметр A',
    algoVarsTitle: 'Переменные (группы вопросов)',
    algoCodeTitle: 'Алгоритм',
    algoRefFunctions: 'Функции',
    algoRefOps: 'Операторы',
    algoRefActions: 'Действия',
    algoRefTakeAll: 'для всех необработанных вопросов',
    algoRefTakeHint: 'берёт из переменной условия; без условия — из всех оставшихся вопросов',
    algoRefVars: 'Переменные',
    editorOffline: '● Нет связи, работа локально',
    editorSyncing: 'Синхронизация...',
    editorSaved: 'Сохранено ✓',
    editorErrorCreate: 'Не удалось создать тест',
    editorErrorSave: 'Не удалось сохранить тест',

    // TestPage — info popup
    testInfoTooltip: 'Информация',
    testInfoTitle: 'Информация',
    testInfoClose: 'Закрыть',

    // UsersPage
    usersTitle: 'Пользователи',
    usersBtnCreate: '+ Создать пользователя',
    usersHideGuests: 'Скрыть гостей',
    usersShown: 'Показано',
    usersColUsername: 'Имя пользователя',
    usersColRole: 'Роль',
    usersColStatus: 'Статус',
    usersColCreated: 'Дата создания',
    usersStatusActive: 'Активен',
    usersStatusBlocked: 'Заблокирован',
    usersTooltipEdit: 'Редактировать',
    usersTooltipDelete: 'Удалить',
    usersDeleteConfirm: 'Удалить пользователя «{name}»?',
    usersLoadError: 'Не удалось загрузить пользователей',
    usersDeleteError: 'Ошибка удаления',
    usersModalCreate: 'Создать пользователя',
    usersModalEditPrefix: 'Редактировать',
    usersLabelUsername: 'Имя пользователя',
    usersPlaceUsername: 'Введите логин',
    usersLabelPassword: 'Пароль',
    usersLabelPasswordEdit: 'Новый пароль (оставьте пустым, чтобы не менять)',
    usersPlacePassword: 'Введите пароль',
    usersLabelRole: 'Роль',
    usersLabelStatus: 'Статус',
    usersErrorUsername: 'Введите имя пользователя',
    usersErrorPassword: 'Введите пароль',
    usersErrorCreate: 'Ошибка создания пользователя',
    usersErrorSave: 'Ошибка сохранения',
  },
  en: {
    // LoginPage
    logoAlt: 'Logo',
    loginButton: 'Personal account',
    guestLink: 'Continue as guest',
    closeButton: 'Close',
    closePage: 'Close page',
    guestError: 'Guest login failed',
    modalTitle: 'Admin Login',
    labelLogin: 'Username',
    labelPassword: 'Password',
    passwordPlaceholder: 'Enter password',
    errorEmptyPassword: 'Please enter a password',
    errorBadCredentials: 'Invalid username or password',
    submitLoading: 'Signing in...',
    submitButton: 'Sign in',
    cancelButton: 'Cancel',
    viewResultsLink: 'Search and get results',

    // HomePage (public home)
    homeSubtitle: 'an indicator of hidden meanings',

    // Footer
    footerRequisites: 'Requisites & terms',
    footerOffer: 'Public offer',
    footerConsent: 'Consent to the processing of personal data',
    footerInstruction: 'User guide',
    footerRights: '(c) PsyDecrypt 2026',

    // RequisitesPage
    requisitesTitle: 'Requisites & terms',
    requisitesIntro1: 'The service consists in the paid provision to an anonymous user of information as part of a file and is digital.',
    requisitesIntro2: 'After successful payment, the anonymous user receives a file with a textual description of the session (testing) results. The result file automatically receives a unique alphanumeric code, by which this file can be found on the service and downloaded to the user\'s device.',
    requisitesIntro3: 'No other ways of delivering the service (in the form of an information file) are provided. Access to the result is provided immediately after payment confirmation. To find and download the report by its alphanumeric code, you can use the "Search and get results" button located on the main page.',
    requisitesIntro4: 'To prevent abuse, 3 download attempts of one paid file are provided by default. Further access to the file is possible through the form for contacting the service administration on the website www.psydecrypt.online or by e-mail: psydecrypt@mail.ru',
    requisitesPricesTitle: 'Prices',
    requisitesPriceIndividual: 'Psychological self-portrait (1 conclusion) — ₽499',
    requisitesPriceComparison: 'Comparison of two psychological profiles — ₽499',
    requisitesPriceInfo: 'The list of services is expanding; the cost of services ordered through specialists is clarified by the administration.',
    requisitesOfferTitle: 'Public offer',
    requisitesOfferText: 'The public offer is published on the Psydecrypt Online website:',
    requisitesRequisitesTitle: 'Entrepreneur requisites',
    requisitesName: 'IP Pilyugin Alexander Borisovich',
    requisitesInn: 'INN: 780411646954',
    requisitesOgrnip: 'OGRNIP: 323784700082881',
    requisitesAccount: 'Account: 40802810555710075196',
    requisitesBank: 'Bank: SEVERO-ZAPADNY BANK PJSC SBERBANK',
    requisitesBik: 'BIK: 044030653',
    requisitesKor: 'Correspondent account: 30101810500000000653',
    requisitesBankInn: 'Bank INN: 7707083893',
    requisitesBankKpp: 'Bank KPP: 784243001',

    // PrivacyPage — consent to personal data processing
    privacyTitle: 'User consent to the processing of personal data',
    privacyP1: 'Hereby, acting freely, of my own free will and in my own interest, I give my consent to IP Pilyugin Alexander Borisovich (OGRNIP 323784700082881) for the processing of my personal data for the purpose of paid provision of the digital service to me through the web service "Psydecrypt".',
    privacyP2: 'I am aware that this web service does not collect, verify or store any personal data of anyone, and that registration and providing personal data are not required to receive the digital service on the "Psydecrypt" server. Access to the files with target information is carried out by an alphanumeric code generated automatically by the web service for each individual session. This code is assigned to files, the content of which is purchased by the user for a fee.',
    privacyP3: 'At the same time, I can, at my own discretion, voluntarily enter data into the result identification fields (name, address, other details). Such data are not verified, are used only to associate the result file and are not transferred to third parties, except in cases provided by law. At the same time, I know that I can enter any, both real and fictitious, data about myself, or not enter anything.',
    privacyP4: 'Payment for digital services is made through a third-party payment service. Payment data are processed by its operator in accordance with its privacy policy.',
    privacyP5: 'I understand and accept possible risks: the conclusion based on the results of my performance of test tasks is formed automatically by an LLM model, including, but not limited to, the use of artificial intelligence technologies. The information in the conclusion is information for review and is not a medical or psychological conclusion, diagnosis or recommendation. Also, the conclusion does not replace a specialist consultation. The results may contain inaccuracies, including due to the inevitable incompleteness of the psychological testing method.',
    privacyP6: 'The user consent is valid until it is withdrawn. You can withdraw consent by e-mail psydecrypt@mail.ru or through the contact form on the website psydecrypt.online.',
    privacyConsentLabel: 'I consent to the processing of personal data and understand the risks of using the "Psydecrypt" web service',

    // OfferPage — public offer
    offerTitle: 'PUBLIC OFFER',
    offerSubtitle: 'for the provision of information and analytical (digital) services',
    offerMetaCity: 'Saint Petersburg',
    offerMetaDate: 'Publication date: October 20, 2026',
    offerIntro: 'This document is a public offer (hereinafter — the "Offer") of the Individual Entrepreneur Pilyugin Alexander Borisovich (OGRNIP: 323784700082881, INN: 780411646954) (hereinafter — the "Executor") and contains all essential terms of the contract for the paid provision of information and analytical services to any person who accepts the terms of this Offer (hereinafter — the "Customer").',
    offerS1Title: '1. TERMS AND DEFINITIONS',
    offerS1_1: '1.1. Service — the "Psydecrypt" web service available at: https://www.psydecrypt.ru (hereinafter — the Service), which is a software complex for testing and generating analytical reports using artificial intelligence technologies.',
    offerS1_2: '1.2. Website — the information resource of the Executor, available at: https://www.psydecrypt.online.',
    offerS1_3: '1.3. Service (the provided service) — granting the Customer access to a digital file (report) generated by the Service based on the answers provided by the Customer when completing test tasks of their choice.',
    offerS1_4: '1.4. Acceptance — full and unconditional consent of the Customer to the terms of the Offer, expressed by making payment for the Services.',
    offerS1_5: '1.5. Code — a unique alphanumeric code generated automatically by the Service to identify a session and access the purchased file with the result.',
    offerS2Title: '2. SUBJECT OF THE CONTRACT',
    offerS2_1: '2.1. The Executor undertakes to provide the Customer with Services for granting access to digital testing results (information and analytical reports), and the Customer undertakes to pay for these Services.',
    offerS2_2: '2.2. The list of available Services, their detailed description and current cost are posted on the Executor\'s Website in the "Proposals and terms of their order" section ( https://www.psydecrypt.online ).',
    offerS2_3: '2.3. The Services are not medical, psychological or psychiatric. The results are exclusively informational for review and cannot be considered a diagnosis or a guide to action, and also do not replace a consultation with a qualified specialist.',
    offerS3Title: '3. PROCEDURE FOR PROVIDING SERVICES',
    offerS3_1: '3.1. To receive the Service, the Customer takes a test on the web service located at https://www.psydecrypt.ru, which is part of the website https://www.psydecrypt.online.',
    offerS3_2: '3.2. Based on the results of the test chosen by the consumer (Customer), the Service generates a file with text information, the name of which contains a unique Code, of the RE4WK2HT type, under which this file is found by the Customer, paid for, and then can be downloaded.',
    offerS3_3: '3.3. The Service is digital. Delivery of physical media is not provided.',
    offerS3_4: '3.4. The Service is considered properly rendered and in full from the moment the Customer is granted access to the file with the result (report) by the generated code immediately after confirmation of successful payment.',
    offerS3_5: '3.5. To receive the Service, the Customer does not need to register or provide their personal data. Any information (name, address, etc.) entered by the Customer in the identification fields is used solely to associate the file and is not verified for correctness by the Executor. The Customer has the right to provide fictitious data or leave the fields empty.',
    offerS4Title: '4. COST OF SERVICES AND PAYMENT PROCEDURE',
    offerS4_1: '4.1. The cost of Services is determined by the Executor in Russian rubles and is indicated on the Website ( https://www.psydecrypt.online ).',
    offerS4_2: '4.2. Payment for Services is made by bank transfer in the form of 100% prepayment through a third-party payment service (YooKassa / LLC NKO "YooMoney"). The Customer\'s payment data (bank card data) is processed exclusively by the operator of the third-party payment system.',
    offerS4_3: '4.3. By making payment, the Customer confirms that they have read, agree with and accept the terms of this Offer, and also give consent to the processing of personal data in accordance with the Privacy Policy posted on the Website.',
    offerS5Title: '5. REFUND PROCEDURE',
    offerS5_1: '5.1. Due to the fact that the Service is digital and is considered rendered at the moment of granting access to the file by the Anonymous code, refunds after granting access to the result are not made, except for cases directly provided for by the legislation of the Russian Federation.',
    offerS5_2: '5.2. If the payment was made, but the Service was not rendered for technical reasons (for example, a failure in the Service that does not allow generating a code or gaining access to the result), the Customer has the right to apply for a refund at the e-mail address: psydecrypt@mail.ru. The refund is made to the same bank card from which the payment was made, within the terms established by the rules of the payment system.',
    offerS6Title: '6. RIGHTS AND OBLIGATIONS OF THE PARTIES',
    offerS6_1: '6.1. The Executor undertakes to ensure the operability of the Service and provide access to the result after successful payment.',
    offerS6_2: '6.2. The Customer undertakes to pay for the selected Service and not to use the results for illegal purposes.',
    offerS6_3: '6.3. The Executor has the right to make changes to the terms of the Offer and the cost of Services without prior notice. Changes take effect from the moment of publication on the Website.',
    offerS7Title: '7. LIMITATION OF LIABILITY AND SPECIFICS OF WORKING WITH AI',
    offerS7_1: '7.1. The Customer understands and accepts that reports are formed automatically by the LLM model configured by the Executor using artificial intelligence technologies.',
    offerS7_2: '7.2. The Executor does not guarantee absolute accuracy, objectivity or completeness of generated reports, since they depend on the data entered by the Customer, the chosen methodology and the algorithms of the LLM model. The results may contain inaccuracies due to the inevitable incompleteness of the psychological testing method and the limitations of the algorithms used, as well as the peculiarities of the Customer\'s performance of test tasks.',
    offerS7_3: '7.3. The Executor is not responsible for the Customer\'s emotional perception of the results received, as well as for any decisions, actions or inaction of the Customer taken on the basis of familiarization with the report.',
    offerS8Title: '8. PERSONAL DATA',
    offerS8_1: '8.1. Processing of personal data (if voluntarily provided by the Customer) is carried out in accordance with a separate document — "Consent to the processing of personal data", posted on the Website: https://www.psydecrypt.online.',
    offerS9Title: '9. EXECUTOR\'S DETAILS',
    offerS9Name: 'Individual Entrepreneur Pilyugin Alexander Borisovich',
    offerS9Details: 'INN: 780411646954\nOGRNIP: 323784700082881\nBank: SEVERO-ZAPADNY BANK PJSC SBERBANK\nAccount: 40802810555710075196\nBIK: 044030653\nCorr. account: 30101810500000000653',
    offerS9ContactsTitle: 'Contact details:',
    offerS9Phone: 'Phone: +7-961-612-47-20',
    offerS9Email: 'E-mail: psydecrypt@mail.ru',
    offerS9Site: 'Website: https://www.psydecrypt.online',
    offerConsentLabel: 'I have read the terms of the public offer and accept them',

    // TestsPage
    pageTitle: 'Choose the method you want to use and click the "Run test" button',
    greeting: 'Hello',
    navUsers: 'Users',
    navResults: 'Results',
    createTest: 'Create test',
    importTest: 'Import test from file',
    importError: 'Failed to import test',
    logout: 'Log out',
    loading: 'Loading tests...',
    errorPrefix: 'Error',
    stimuliLabel: 'Questions',
    publishedLabel: 'Published',
    publishedYes: 'Yes',
    publishedNo: 'No',
    startTest: 'Run test',
    noStimuli: 'No available questions',
    unpublish: 'Unpublish',
    publish: 'Publish',
    noVisibleStimuli: 'No visible questions',
    exportTest: 'Export test',
    editTitle: 'Edit',
    deleteTitle: 'Delete test',
    testsDisplayScaleLabel: 'Card size:',
    testsDisplayDragHint: 'Drag a card with the mouse or set its queue number from the top-left.',
    testsDisplayDragHandle: 'Drag card',
    testsDisplayOrderTitle: 'Queue number (from top-left)',
    testsDisplaySaved: 'Display settings saved',
    testsDisplaySaveError: 'Failed to save display settings',
    testsDisplaySaving: 'Saving…',
    deleteConfirmPrefix: 'Delete test',
    deleteConfirmSuffix: '? This action cannot be undone.',

    // TestPage — test flow
    testLoading: 'Loading test...',
    testNotFound: 'Test not found',
    testNoStimuli: 'This test has no available questions.',
    testPaused: 'Test paused',
    testResume: 'Resume',
    btnBack: '← Back',
    btnSubmitCustomAnswer: 'Submit answer',
    btnOk: 'Got it',
    questionCounter: 'of',
    customAnswerPlaceholder: 'Your answer...',
    customAnswerOpen: 'My answer',
    customAnswerTitle: 'Your own answer',
    clicksProgress: 'Clicks: {k} of {n}',
    scaleConfirm: 'I confirm my answer',

    // TestPage — participant form
    formTitle: 'Tasks completed successfully!',
    formSubtitle: 'Please fill in the form to receive your results',
    formName: 'What should we call you?',
    formNameOptional: '(optional)',
    formNamePlaceholder: 'Enter your name or alias',
    formDevice: 'Device',
    formDeviceDefault: 'Select device...',
    formDevicePC: 'Computer / laptop',
    formDevicePhone: 'Phone',
    formDeviceTablet: 'Tablet',
    formEmail: 'Where to send results',
    formEmailPlaceholder: 'email@example.com',
    formAge: 'Age',
    formAgePlaceholder: 'Your age',
    formGender: 'Gender',
    formGenderNone: 'Not specified',
    formGenderMale: 'Male',
    formGenderFemale: 'Female',
    formSubmitting: 'Sending...',
    formSubmit: 'Request results',
    formSubmitError: 'Failed to save the result. Check your connection and try again — your answers are not lost.',
    formSkipSave: 'Don\'t save results',
    settingsPublicResults: 'Allow public results search',
    resultsSettingsError: 'Failed to save the setting',
    resultCodePlaceholder: 'e.g., 1ABCDEF2',
    resultOpen: 'Open results',
    resultPageTitle: 'Checking the presence of a session results file',
    resultCodeLabel: 'Result code',
    resultCodePrompt: 'Enter the alphanumeric code of the session you are interested in',
    resultCodeRequired: 'Enter the result code',
    resultCodeInvalid: 'The code contains 6–15 Latin letters or digits',
    findConclusion: 'Find conclusion',
    compareProfiles: 'Compare psychoprofiles',
    compareProfilesHint: 'Enter the codes of the psychoprofile descriptions to be compared',
    compareCode1Label: 'enter the code of the first psychoprofile',
    compareCode2Label: 'enter the code of the second psychoprofile',
    compareMissing: 'no conclusion found for code {code}',
    compareCodeIsComparison: 'code {code} belongs to a comparison conclusion, not an individual psychoprofile',
    compareOpenExisting: 'Open existing comparison',
    compareSameCode: 'Enter two different codes',
    compareTestLabel: 'Test',
    compareDifferentTest: 'Conclusions were obtained from different tests ({t1} and {t2}). Comparison is not available.',
    compareGetResultBtn: 'Get comparison result',
    comparePageTitle: 'Compare psychoprofiles',
    compareResultTitle: 'Comparison of psychoprofiles',
    compareResultPrice: 'Comparison price',
    compareNotFound: 'Comparison with this code not found',
    compareLoadError: 'Could not load the comparison. Check the codes and server availability.',
    compareResultBack: 'Back to previous window',
    comparePayment: 'Pay and get the conclusion',
    comparePaymentLoading: 'Redirecting to payment...',
    compareDownload: 'Download conclusion ({n})',
    compareProcessingInfo: 'The comparison is being generated. The result will be available within 10–15 minutes.',
    comparePurposeLabel: 'Comparison purpose',
    comparePurposePlaceholder: 'Select the purpose of comparison (optional)',
    comparePurposeAny: 'General comparison (no purpose selected)',
    comparePurposeDescriptionLabel: 'Purpose details',
    comparePurposeDescriptionPlaceholder: 'e.g., we want to assess compatibility of future business partners...',
    comparePurposeConfirm: 'The purpose is taken into account when generating the conclusion',
    resultStatusLabel: 'Status',
    resultPaidLabel: 'Test paid',
    resultPdfLink: 'Download results PDF',
    resultWalletOnePayment: 'Pay and get the conclusion',
    resultPaymentLoading: 'Redirecting to payment...',
    resultLoadError: 'Could not load the result. Check the code and server availability.',
    resultCodeNotFound: 'The file under this code was not found. Check the correctness of the entered code or contact the service administration via the feedback form on the website www.psydecrypt.online',
    resultBackToCode: 'Back to the code entry page',
    resultPaymentError: 'Could not contact Wallet One or the server. Please try again.',
    resultPaymentFormLabel: 'Wallet One payment redirect form',
    resultPaymentNotConfigured: 'Payments are not configured on the server yet. Contact the administrator.',
    resultPaymentResultNotFound: 'No result was found for this code.',
    resultStatus_processing: 'Processing',
    resultStatus_awaiting_payment: 'Awaiting payment',
    resultStatus_results: 'Results',
    resultStatusRejected: 'Processing rejected',
    resultStatusPaidAvailableOne: 'Paid. 1 download left',
    resultStatusPaidAvailableFew: 'Paid. ({n}) downloads left',
    resultStatusLimitReached: 'Download limit reached',
    resultPriceLabel: 'Price',
    resultCurrency: '₽',
    resultPaymentSuccess: 'Payment submitted. We are checking its status.',
    resultPaymentFail: 'Payment was not completed. Check the payment status below.',
    resultPaymentRedirect: 'Redirecting to payment...',
    resultPaymentUnavailable: 'The payment form is unavailable. Please try again later.',
    resultProcessingInfo: 'The raw data are currently being processed and the conclusion is being generated. The result will be available within 10–15 minutes. This page will refresh automatically.',
    resultGeneratingInfo: 'Exchanging data with the analysis service… {s}',
    resultProcessingWait: 'Your requested result is being processed. Please wait',
    resultQueuedInfo: 'Your request has been queued. There are {n} requests ahead of you. The conclusion will appear automatically when its turn comes.',
    resultGenerationServiceError: 'The AI service is not responding. Please contact the administrator at psydecrypt@mail.ru or try again later.',
    resultProcessError: 'Failed to start processing. Please try again later.',
    resultRetryButton: 'Try again',
    resultRetryAfter: 'Retry in {n} sec.',
    resultAttemptsExceeded: 'The attempt limit has been reached. Please contact the administrator at psydecrypt@mail.ru.',
    resultAwaitingPaymentInfo: 'The conclusion is ready. Pay to access your results.',
    resultResultsInfo: 'Payment confirmed. Your results are available for download.',
    resultConclusionInfo: 'If you have any questions, please contact the service administration via the form on the website: https://www.psydecrypt.online/, quoting the session result code in the form XXXXXXXX',
    resultDownloadButton: 'Download conclusion ({n})',
    resultDownloadUnavailable: 'The conclusion has not been created yet',
    resultPdfDownloadError: 'Failed to download PDF',
    resultPdfPaymentRequired: 'Download is available after payment',
    resultDownloadRequiresPayment: 'The conclusion will be available after payment',
    resultDownloadsInfoOne: 'The conclusion is available (1 more download)',
    resultDownloadsInfoFew: 'The conclusion is available ({n} more downloads)',
    resultDownloadLimitReached: 'This conclusion has been paid for but has already been downloaded the prescribed number of times ({times}). For each further copy, please contact the service administration at: https://www.psydecrypt.online',
    compareDownloadPlaceholder: 'Download comparison result',

    // Share code / compare
    shareCodeTitle: 'Your result code',
    shareCodeCopy: 'Copy',
    shareCodeCopied: 'Copied!',
    dbTransferTitle: 'Database management',
    dbTransferSubtitle: 'Export the full DB archive and import with "add missing" mode: existing records are not overwritten.',
    dbExportLabel: 'Export',
    dbExportDesc: 'Download the entire current DB archive (all tables + PDFs) as a JSON file.',
    dbExportBtn: 'Download DB archive',
    dbImportLabel: 'Import',
    dbImportDesc: 'Select a JSON DB archive from another service. Only missing records will be added; matching records are skipped.',
    dbImportDrop: 'Drop the file here',
    dbImportBtn: 'Add missing only',
    dbImportLoading: 'Importing…',
    dbImportSuccess: 'Import completed',
    dbImportError: 'Import failed',
    dbStatsLabel: 'Current DB',
    dbExportLoading: 'Exporting…',
    dbImportFileSelected: 'Selected file: {name}',
    dbProgressDownload: 'Downloading DB archive…',
    dbProgressUpload: 'Uploading DB archive…',
    dbProgressWait: 'Please wait…',
    dbIncludePdfs: 'Include PDF files (conclusions)',
    dbMaxArchiveSize: 'Maximum archive size: {size}',
    dbExportedSize: 'Downloaded: {size}',
    dbNearLimit: 'Archive is close to the transfer limit ({size} of {limit}). At {limit} import will become impossible — keep a DB backup.',
    dbFileTooLarge: 'File exceeds the {size} limit — import impossible. Export the archive without PDFs or keep a DB backup.',
    dbReportPdf: 'PDF',
    dbPdfNotFound: 'PDFs were not included in the archive. They can be regenerated on this server (the "PDF" button on a conclusion).',
    dbImportReportAdded: 'Added',
    dbImportReportSkipped: 'Skipped',
    dbImportReportErrors: 'Errors',
    backBtn: '← Back',
    testTitle: 'Test',
    dbScenarioTitle: 'Transfer scenario with graphics',
    dbScenarioDesc: 'Export a test together with its images/videos (zip bundle) from one instance and import on another. Media and links are restored automatically.',
    dbScenarioExportLabel: 'Export scenario',
    dbScenarioExportDesc: 'Select a test — a zip with its JSON scenario and all media files is downloaded.',
    dbScenarioExportHint: 'Only files referenced by the scenario are included in the bundle.',
    dbScenarioExportBtn: 'Download scenario bundle',
    dbScenarioExporting: 'Exporting…',
    dbScenarioNoTests: 'No tests',
    dbScenarioImportLabel: 'Import scenario',
    dbScenarioImportDesc: 'Upload a scenario zip bundle. Media is restored; the test is added without duplicates.',
    dbScenarioDrop: 'Drop the zip bundle here',
    dbScenarioImportBtn: 'Upload bundle',
    dbScenarioImporting: 'Importing…',
    dbScenarioImportError: 'Scenario transfer failed',
    dbScenarioExportError: 'Failed to export scenario bundle',
    dbScenarioBadFile: 'Select a .zip file (scenario bundle)',
    dbScenarioMediaMissing: 'Warning: {n} media file(s) not found in the archive — links will remain as-is.',
    dbScenarioResultOk: 'Import finished: {questions} questions, {options} options; media added {media_added}, already existed {media_skipped}.',
    dbScenarioResultDuplicate: 'Test «{title}» already exists — skipped.',

    // Conclusion
    conclusionTitle: 'Conclusion',
    conclusionLoading: 'Getting conclusion...',
    conclusionGetBtn: 'Get conclusion',
    conclusionError: 'Error getting conclusion',
    conclusionResponse: 'Conclusion text',
    navConclusions: 'Conclusions',
    navDbTransfer: 'DB management',
    navMedia: 'Media library',
    navBack: 'Back to tests',
    mediaTitle: 'Media library',
    mediaUploadBtn: 'Upload media',
    mediaUploadTitle: 'Upload file',
    mediaFileLabel: 'File (image or video up to 3 min)',
    mediaTitleLabel: 'Title',
    mediaDescLabel: 'Description',
    mediaTagsLabel: 'Tags',
    mediaLoading: 'Loading…',
    mediaEmpty: 'No files in the media library yet. Upload the first one.',
    mediaUploadError: 'Failed to upload file',
    mediaLoadError: 'Failed to load media library',
    mediaSaveError: 'Failed to save changes',
    mediaUploading: 'Uploading…',
    mediaEditBtn: 'Edit',
    mediaDeleteBtn: 'Delete',
    mediaEditTitle: 'Edit media',
    mediaSaveBtn: 'Save',
    mediaDeleteConfirm: 'Delete this file from the media library?',
    mediaCopyLink: 'Copy link',
    mediaCopied: 'Copied',
    mediaCopyError: 'Failed to copy link',
    mediaSearchPlaceholder: 'Search by title, file, description, tags…',
    mediaNoMatch: 'Nothing found. Refine your query.',
    mediaTagClickHint: 'Show files with this tag',
    conclusionsPageTitle: 'Conclusions management',
    conclusionsEmpty: 'No saved conclusions',
    conclusionsLoading: 'Loading...',
    conclusionEdit: 'Edit',
    conclusionSave: 'Save',
    conclusionSaving: 'Saving...',
    conclusionSaveError: 'Save error',
    conclusionPdf: 'Download PDF',
    conclusionPdfError: 'Failed to save conclusion',
    conclusionPdfDownload: 'Download PDF',
    conclusionPdfDownloading: 'Downloading...',
    conclusionPdfDownloadError: 'Failed to download PDF',
    conclusionPdfPaymentRequired: 'Download is available after payment',
    conclusionGenerate: 'Generate conclusion',
    conclusionGenerateColor: 'Generate raw data',
    conclusionGenerating: 'Generating...',
    conclusionGenerateError: 'Generation error',
    conclusionGeneratingInfo: 'Exchanging data with the external service... {s}',
    conclusionRegenerateConfirm: 'A conclusion already exists for this result. Replace it with a new one?',
    conclusionTimeChart: 'Time chart',
    conclusionViewAnswers: 'View answers',
    conclusionRequestBtn: 'Request conclusion',
    conclusionRequested: 'Requested ✓',
    conclusionRequestError: 'Failed to request conclusion',
    conclusionNoText: '(text not yet generated)',
    conclusionTextPlaceholder: 'Conclusion text will appear here...',
    conclusionSaveChanges: 'Save text edit',
    conclusionDraftSaved: 'Draft saved. The number will change after generation',
    conclusionEditInfo: 'revision #{n} from {d}',
    pdfTitle: 'Psychological Assessment',
    pdfParticipant: 'Participant',
    pdfAge: 'Age',
    pdfGender: 'Gender',
    pdfDevice: 'Device',
    pdfDate: 'Date',
    pdfTest: 'Test',
    pdfCode: 'Code',
    detailResults: 'Results',
    conclusionsColType: 'Conclusion type',
    conclusionsColCode: 'Code',
    conclusionsColDate: 'Date',
    conclusionsColPreview: 'Preview',
    conclusionsColGeneration: 'Generation status',
    conclusionsTypeIndividual: 'Individual',
    conclusionsTypeGroup: 'Group',
    conclusionsTypeComparison: 'Comparison',
    conclusionsColDownloadLimit: 'Download limit',
    conclusionsColVisibility: 'Conclusion visibility',
    conclusionsColAllowUnpaid: 'Download without payment',
    conclusionsColPayment: 'Payment',
    conclusionsColPublicCount: 'Downloaded (public)',
    conclusionsColTotalCount: 'Downloaded (total)',
    conclusionsColAdminAction: 'Actions',
    conclusionsResetDownloads: 'Reset counters',
    conclusionsMarkPaid: 'Mark as paid',
    conclusionsDownloadLimitPlaceholder: '0…10',
    conclusionsDownloadLimitDefault: '3 (default)',

    // ConclusionsListPage — admin actions and messages
    conclusionsBtnPay: 'Pay',
    conclusionsBtnUnmarkPaid: '↩ Unmark paid',
    conclusionsBtnUnmarkPaidTitle: 'Remove manual paid mark (back to not paid)',
    conclusionsConfirmUnmarkPaid: 'Remove manual paid mark for this conclusion?',
    conclusionsUnmarkPaidDone: 'Manual paid mark removed',
    conclusionsBtnPayTitle: 'Mark as paid',
    conclusionsBtnResetTitle: 'Reset counter',
    conclusionsBtnDeleteTitle: 'Delete',
    conclusionsPaymentNone: 'no',
    conclusionsPaymentManual: 'manual',
    conclusionsDownloadedCount: 'Downloaded: {n} of {m}',
    conclusionsConfirmReset: 'Reset the download counter?',
    conclusionsConfirmAction: 'Confirm',
    conclusionsConfirmDelete: 'Delete conclusion?',
    conclusionsResetDone: 'Counter reset. Downloaded: {n} of {m}.',
    conclusionsErrorUpdateLimit: 'Failed to update download limit',
    conclusionsErrorUpdateVisibility: 'Failed to update conclusion visibility',
    conclusionsErrorUpdateUnpaid: 'Failed to update the no-payment flag',
    conclusionsErrorMarkPaid: 'Failed to mark as paid',
    conclusionsErrorReset: 'Failed to reset the counter',
    conclusionsErrorDelete: 'Failed to delete',
    conclusionsLoadError: 'Failed to load the conclusions list',
    conclusionsPdfDownloadError: 'Failed to download PDF',
    conclusionsPdfDownloadTitle: 'Download conclusion PDF',
    conclusionsOpenTitle: 'Open conclusion (PDF not generated yet)',
    conclusionsSourceExist: 'source exists',
    conclusionsSourcePartialMissing: 'partially removed: {ids}',
    conclusionsSourceMissing: 'source removed: {ids}',
    conclusionsHideOrphans: 'Hide without source',
    conclusionsJobsProcessing: 'Processing: {p}',
    conclusionsJobsQueued: 'queued: {q}',
    conclusionsColGenerating: 'Generating…',
    conclusionsCodeSearch: 'Search by conclusion code',
    conclusionsDeleteOrphans: 'Delete without source',
    conclusionsConfirmDeleteOrphans: 'Delete conclusions without primary results ({n})?',
    conclusionsDeletedOrphans: 'Conclusions deleted: {n}',
    conclusionsNoVisible: 'All conclusions are hidden by the filter',
    conclusionExistsLink: 'Conclusion exists →',
    conclusionExistsShort: 'Conclusion exists',
    conclusionAbsentShort: 'No conclusion',
    conclusionSourceCodes: 'Source codes',
    conclusionSourceMissing: 'Source removed (IDs)',

    // Scroll to top button (ResultsPage, ConclusionPage)
    scrollTopTitle: 'Top',

    // ConclusionPage — label strings for the conclusion editor
    conclusionUpdate: 'Update',
    conclusionCoefficient: 'Coefficient',
    conclusionParameter: 'Parameter {letter}',
    conclusionInAlgorithm: 'Used in algorithm: {vars}',
    conclusionRequiredFields: '⚠ Fill required fields',
    conclusionSavedMark: '✓ saved',
    conclusionCustomLoadError: 'Failed to load custom answers',
    conclusionCustomSaveError: 'Failed to save',
    conclusionDeleteConfirm: 'Delete this conclusion?',
    conclusionDeleteError: 'Failed to delete',
    conclusionModeRaw: 'Raw primary data',
    conclusionModeSaved: 'Conclusion text',
    conclusionRawHint: 'The field contains the raw metadata. You can send it to the LLM to get an alternative conclusion (new version).',
    conclusionVersionPublic: 'public',
    conclusionVersionHidden: 'hidden',
    conclusionVersionVisibleToPublic: 'Visible to external users',
    conclusionVersionVisible: 'The conclusion version is now visible to external users',
    conclusionVersionHiddenDone: 'The conclusion version is hidden from external users',
    conclusionVersionCode: 'Version code: {code}',
    conclusionParticipantFallback: 'Participant',

    // TestPage — thank you screen
    thanksTitle: 'Thank you for participating',
    thanksResultsLink: 'Open results',
    thanksContact: 'If you have any questions, please contact the service administration:',

    // MyResultsPage
    navMyResults: 'My Results',
    myResultsTitle: 'My Results',
    myResultsEmpty: 'No results yet',
    myResultsColTest: 'Test',
    myResultsColDate: 'Date',
    myResultsColTime: 'Time (sec)',
    myResultsColCompare: 'Compare',
    myResultsColQuestion: 'Question',
    myResultsColAnswer: 'Answer',
    myResultsColTimeMs: 'Time (ms)',

    // Common / shared
    genLoading: 'Loading...',
    genSaving: 'Saving...',
    genCreate: 'Create',
    genSave: 'Save',
    genDelete: 'Delete',
    genCancel: 'Cancel',

    // ResultsPage
    resultsTitle: 'Testing Results',
    resultsLoading: 'Loading results...',
    resultsLoadError: 'Failed to load results. Check your connection and try again later.',
    resultsAllTests: 'All tests',
    resultsSearch: 'Search by user, name, email...',
    resultsCols: 'Columns ▾',
    resultsEmpty: 'No results',
    resultsShown: 'Shown',
    resultsFrom: 'of',
    resultsSelectedCount: 'Selected',
    resultsWithParams: 'With questions parameters',
    resultsExportBtn: 'Detailed export',
    resultsDeleteBtn: 'Delete selected',
    resultsDeletingLabel: 'Deleting...',
    resultsViewBtn: 'View answers',
    resultsViewTooMany: 'Too many (max 5)',
    resultsViewDiffTests: 'Different tests',
    resultsTipMax5: 'Up to 5 participants at a time',
    resultsTipOneTest: 'Only results from a single test',
    resultsDeleteConfirm: 'Delete {n} result(s)? This action cannot be undone.',
    resultsDeleteError: 'Failed to delete results',
    resultsViewError: 'Failed to load result details',
    resultsTooManyAlert: 'You can compare up to 5 participants at a time',
    resultsDiffTestsAlert: 'You can only compare results from a single test',
    resultsColId: 'ID',
    resultsColTest: 'Test',
    resultsColUser: 'User',
    resultsColName: 'Name',
    resultsColDevice: 'Device',
    resultsColAge: 'Age',
    resultsColGender: 'Gender',
    resultsColTime: 'Time (sec)',
    resultsColDate: 'Date',
    resultsColShareCode: 'Code',
    resultsColPdf: 'PDF',
    resultsColPayment: 'Payment',
    resultsColDownloads: 'Downloads',
    resultsPdfDownload: 'Download',
    resultsPdfDownloadError: 'Failed to download PDF',
    resultsPdfPaymentRequired: 'Download is available after payment',
    resultsLoadMore: 'Load more',
    resultsPartialLoad: 'Loaded {n} of {total}',
    editorAutoSaveError: '⚠ Auto-save error',

    // ResultDetailView
    detailBack: '← Back to list',
    detailTitle: 'View answers',
    detailParticipant1: 'participant',
    detailParticipantsN: 'participants',
    detailSearch: 'Search by questions text...',
    detailOnlyAnswered: 'Only answered',
    detailStimuliLabel: 'questions',
    detailColN: '#',
    detailColStimulus: 'Questions',
    detailNoStimuli: 'No questions',
    detailMs: 'ms',
    detailCustomAnswerLabel: 'free',

    // TestEditorPage
    editorTitleNew: 'Create test',
    editorTitleEdit: 'Edit test',
    editorRestoreMsg: 'Unsaved session found. Restore last changes?',
    editorRestore: 'Restore',
    editorDiscard: 'Discard',
    editorLabelName: 'Test title *',
    editorPlaceName: 'Enter test title',
    editorErrorName: 'Title is required',
    editorLabelDesc: 'Description',
    editorPlaceDesc: 'Enter test description',
    editorLabelMethodology: 'Methodology indicator',
    editorPlaceMethodology: 'e.g. Шкала СД (методика ЧОУ-3)',
    editorMethodologyHint: 'AI uses this indicator to pick the prompt for processing the result. Leave empty to process directly without special instructions.',
    editorColorModeLabel: 'Colorimeter mode',
    editorColorModeHint: 'In colorimeter mode, participants choose from 8 colored cells. Text response options are not used.',
    editorColorLabelsTitle: 'Color labels',
    editorColorLabelsHint: 'Enter names for 8 color labels (empty → hex code)',
    editorColorPairIndexTitle: 'IC matrix (color-pair index)',
    editorColorPairIndexHint: 'Value at row (first click) × column (second click). 8×8, 0–1.',
    editorLabelShuffle: 'Shuffle ranges',
    editorPlaceShuffle: 'e.g.: 1-5, 8-12',
    editorShuffleHint: 'Questions in each range will be randomly shuffled when the test starts. Numbers are 1-based, matching question order.',
    editorShuffleErrorFormat: 'Invalid format. Use: 1-5, 8-12',
    editorShuffleErrorOrder: 'Range start cannot be greater than end',
    editorShuffleErrorMax: 'Range end exceeds question count ({n})',
    editorStimuliSection: 'Questions',
    editorStimulusN: 'Questions',
    editorHiddenBadge: '(hidden)',
    editorBtnCopy: 'Copy',
    editorHideLabel: 'Hide',
    editorCustomAnswerLabel: 'Free answer',
    editorJustifyLabel: 'Justify text',
    editorFontDefault: 'Font: default',
    editorFontTitle: 'Stimulus font size during the test',
    editorClicksDefault: 'Clicks: 1',
    editorClicksTitle: 'How many clicks on answer keys before the next stimulus (not more than number of keys)',
    editorBtnDelete: 'Delete',
    editorLabelStimulusText: 'Questions text',
    editorLabelStimulusMedia: 'Stimulus image (URL from Media library)',
    editorPlaceStimulusMedia: 'E.g. /api/media/12/file',
    editorStimulusMediaHint: 'Paste the link from the media library to present an image/video as a stimulus. A filled image field makes the stimulus a media type.',
    editorPlaceStimulusText: 'Enter questions text',
    editorLabelInfo: 'Info for participant (ℹ button)',
    editorPlaceInfo: 'Additional info the participant can open by clicking ℹ during the test',
    editorLabelExposition: 'Exposition (sec)',
    editorPlaceNoLimit: '0 = no limit',
    editorHintNoLimit: '0 = no time limit',
    editorMetaStimulus: 'Questions meta (a-z)',
    editorHideColorLabels: 'Hide color labels',
    editorHideColorLabelsHint: 'When enabled, the stimulus is shown without color selection — only a "Continue" button',
    editorLabelOptions: 'Response options',
    editorAnswerFormLabel: 'Answer form',
    editorAnswerFormButtons: 'Buttons (response options)',
    editorAnswerFormScale: 'Scale (semantic differential)',
    editorAnswerFormScaleHint: 'Slider with ticks and a "Next" button; score = scale value',
    editorOptionPlaceholder: 'Option',
    editorOptionScore: 'Score',
    editorOptionMediaPlaceholder: 'Image URL (media lib / external)',
    editorMetaOptionPrefix: 'Option meta',
    editorMetaOptionSuffix: '(a-z)',
    editorAddOption: '+ Add response option',
    editorAddStimulus: '+ Add questions',
    editorLabelAlgorithm: 'Analysis algorithm (for AI)',
    editorPlaceAlgorithm: 'Describe the rules for interpreting test results for AI...',
    editorAlgorithmHint: 'This text is sent to AI when generating a conclusion for results of this test',
    algoTitle: 'Analysis algorithm',
    algoDefaultLetter: 'Default parameter letter',
    algoDefaultLetterHint: 'Used for questions not assigned to any variable',
    algoAddVariable: '+ Add variable',
    algoVarName: 'Variable name',
    algoVarQuestions: 'Question numbers',
    algoVarQuestionsHint: 'Comma-separated: 1, 3, 7',
    algoVarPosLetter: '+ letter',
    algoVarNegLetter: '− letter',
    algoVarPosLetterHint: 'Parameter when coeff sum ≥ 0',
    algoVarNegLetterHint: 'Parameter when coeff sum < 0',
    algoVarDelete: 'Delete',
    algoHint: 'Algorithm builds text from answer option parameters and sends it to AI (non-colorimeter tests only)',
    algoNoVariables: 'No variables — default letter used for all questions',
    algoColorModeDisabled: 'Analysis algorithm is not used in colorimeter mode',
    algoFuncSum: 'By sum',
    algoFuncPer: 'Per question',
    algoFuncSumHint: 'Sum of all question coefficients in the variable → determines letter for all',
    algoFuncPerHint: 'Each question\'s coefficient is analyzed independently',
    algoRuleSumMin: 'sum',
    algoRuleCoeffMin: 'coeff.',
    algoRuleElse: 'else',
    algoAddRule: '+ Rule',
    algoSingleQuestion: 'Single question — parameter A is used automatically',
    algoVarsTitle: 'Variables (question groups)',
    algoCodeTitle: 'Algorithm',
    algoRefFunctions: 'Functions',
    algoRefOps: 'Operators',
    algoRefActions: 'Actions',
    algoRefTakeAll: 'for all unprocessed questions',
    algoRefTakeHint: 'takes from the condition\'s variable; standalone — from all remaining questions',
    algoRefVars: 'Variables',
    editorOffline: '● Offline, working locally',
    editorSyncing: 'Syncing...',
    editorSaved: 'Saved ✓',
    editorErrorCreate: 'Failed to create test',
    editorErrorSave: 'Failed to save test',

    // TestPage — info popup
    testInfoTooltip: 'Information',
    testInfoTitle: 'Information',
    testInfoClose: 'Close',

    // UsersPage
    usersTitle: 'Users',
    usersBtnCreate: '+ Create user',
    usersHideGuests: 'Hide guests',
    usersShown: 'Shown',
    usersColUsername: 'Username',
    usersColRole: 'Role',
    usersColStatus: 'Status',
    usersColCreated: 'Created at',
    usersStatusActive: 'Active',
    usersStatusBlocked: 'Blocked',
    usersTooltipEdit: 'Edit',
    usersTooltipDelete: 'Delete',
    usersDeleteConfirm: 'Delete user «{name}»?',
    usersLoadError: 'Failed to load users',
    usersDeleteError: 'Delete error',
    usersModalCreate: 'Create user',
    usersModalEditPrefix: 'Edit',
    usersLabelUsername: 'Username',
    usersPlaceUsername: 'Enter username',
    usersLabelPassword: 'Password',
    usersLabelPasswordEdit: 'New password (leave blank to keep unchanged)',
    usersPlacePassword: 'Enter password',
    usersLabelRole: 'Role',
    usersLabelStatus: 'Status',
    usersErrorUsername: 'Enter username',
    usersErrorPassword: 'Enter password',
    usersErrorCreate: 'Failed to create user',
    usersErrorSave: 'Failed to save',
  },
} as const;

export type TranslationKey = keyof typeof translations.ru;

// Словарь en обязан содержать все ключи ru: тип не даст «добавил только в ru» —
// компиляция упадёт с перечнем недостающих ключей.
export type EnDict = Record<TranslationKey, string>;

// Проверка полноты en (тип только, в рантайме не выполняется).
const _enFull: EnDict = translations.en;
